module.exports = __webpack_public_path__ + "img/map_w.65e065a3.svg";